import ContentColumn from './content-column';

export default ContentColumn;